import { render, staticRenderFns } from "./FacilityUsersRolesDialog.vue?vue&type=template&id=9f9888fe&scoped=true"
import script from "./FacilityUsersRolesDialog.ts?vue&type=script&lang=ts&external"
export * from "./FacilityUsersRolesDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9888fe",
  null
  
)

export default component.exports